
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmAcknowledgedIec as ObiAlarmAcknowledgedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-acknowledged-iec.js';
 
 
 

 
 export const ObiAlarmAcknowledgedIec = createComponent({
   react: React,
   tagName: 'obi-alarm-acknowledged-iec',
   elementClass: ObiAlarmAcknowledgedIecElement,
   events: {
     
   }
  });
 
 